import i18next from '@/translation/i18n';

// 투두 상태 코드 (Notification에서 사용)
export enum TodoStatusCode {
    IN_PROGRESS = 'IN_PROGRESS', // 진행 중 상태
    COMPLETED = 'COMPLETED', // 완료 상태
    CANCELLED = 'CANCELLED', // 그만하기 상태
}

export const TodoStatusCodeLabel: Record<TodoStatusCode, string> = {
    [TodoStatusCode.IN_PROGRESS]: i18next.t('todo:status.in_progress'),
    [TodoStatusCode.COMPLETED]: i18next.t('todo:status.completed'),
    [TodoStatusCode.CANCELLED]: i18next.t('todo:status.cancelled'),
};
